import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-4 md:mb-5">
      <div className="flex items-center gap-2.5 min-w-0">
        {icon && (
          <span className="w-8 h-8 md:w-9 md:h-9 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center shrink-0">
            <i className={`${icon} text-base md:text-lg`}></i>
          </span>
        )}
        <div className="min-w-0">
          <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 whitespace-nowrap">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 line-clamp-1 mt-0.5">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="text-sm text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap shrink-0 cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}